import { useEffect, useState } from 'react';

// Generic animated circular score ring with custom color
export function ScoreRing({ value = 0, max = 100, color = '#65A30D', size = 140, stroke = 12, label, sub, center, showValue = true }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (Math.min(value, max) / max) * circ;
  const [disp, setDisp] = useState(0);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 1100;
    const tick = (n) => {
      const t = Math.min(1, (n - start) / dur);
      const e = 1 - Math.pow(1 - t, 3);
      setDisp(Math.round(value * e));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value]);

  return (
    <div className="relative inline-flex items-center justify-center flex-shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="rgba(255,255,255,0.06)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          stroke={color} strokeWidth={stroke} fill="none" strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 1.1s ease-out', filter: `drop-shadow(0 0 10px ${color}77)` }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        {center || (
          <>
            {showValue && <div className="font-mono font-medium" style={{ fontSize: size * 0.3, lineHeight: 1 }}>{disp}</div>}
            {label && <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mt-1">{label}</div>}
            {sub && <div className="text-xs mt-1 font-semibold" style={{ color }}>{sub}</div>}
          </>
        )}
      </div>
    </div>
  );
}

export const STATUS_COLORS = {
  green: '#65A30D',
  lime: '#65A30D',
  orange: '#FFB800',
  red: '#FF5C5C',
  purple: '#A78BFA',
  cyan: '#00C8FF',
};
export const colorOf = (name) => STATUS_COLORS[name] || '#00C8FF';
